"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WWReportId = void 0;
exports.getWWReportIds = getWWReportIds;
exports.getWWReportIdFrom = getWWReportIdFrom;
var WWReportId;
(function (WWReportId) {
    WWReportId["EndOfModulePerformanceReport"] = "ww-eom-performance-report";
    WWReportId["QuestionSetPerformanceReport"] = "ww-question-set-performance-report";
    WWReportId["newReadPerformanceReport"] = "ww-nr-performance-report";
    WWReportId["ParticipationReport"] = "ww-participation-report";
    WWReportId["FQTReport"] = "ww-fqt-performance-report";
    WWReportId["VocabularyReport"] = "ww-voc-performance-report";
    WWReportId["SummaryReport"] = "ww-summary-report";
})(WWReportId || (exports.WWReportId = WWReportId = {}));
function getWWReportIds() {
    return Object.values(WWReportId);
}
function getWWReportIdFrom(value) {
    return getWWReportIds().find(function (type) { return type === value; });
}
